<template lang="pug">
PrSwitch.pr-switch.bordered.nv-el(v-nv v-bind="$props" @nv-enter="switcher" ref="nv")
  .label.text-muted.font-weight-bold.small(v-show="label") {{ label }}
  .switch 
    .indicator
</template>

<script>
import styled from "vue-styled-components"
import { darken } from "polished"

const Props = {
  label: String,
  value: Boolean,
  xsmall: Boolean,
  small: Boolean,
  outline: Boolean
}
const PrSwitch = styled("div", Props)`
  display: flex;
  align-items: center;
  position: relative;

  .label {
    flex-grow: 1;
    overflow: hidden;
    margin-right: 15px;
    white-space: nowrap;
  }
  .switch {
    min-width: 60px;
    max-width: 60px;
    padding: 0 5px;
    position: relative;

    &:before {
      content: "";
      position: absolute;
      border-radius: 5px;
      background: ${props => (props.value ? props.theme.color.primary : darken(0.3, props.theme.color.onSurface))};
      height: 5px;
      left: 0;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    .indicator {
      box-shadow: 0 5px 5px rgba(0, 0, 0, 0.5) !important;
      position: relative;
      z-index: 1;
      width: 20px;
      height: 20px;
      border-radius: 5px;
      background: ${props => (props.value ? props.theme.color.primary : darken(0.2, props.theme.color.onSurface))};
      float: ${props => (props.value ? "right" : "left")};
    }
  }

  &.nv-el-current {
    .switch {
      .indicator {
        border: 2px solid ${props => props.theme.color.primary};
      }
    }
  }

  background: ${props => (props.theme.options.outline || props.outline ? "transparent" : props.theme.color.surface)};
  color: ${props => props.theme.color.onSurface};
  ${props => "border: 1px solid " + (props.outline ? props.theme.color.onSurface : props.theme.color.border) + ";"}
  ${props =>
    props.xsmall
      ? "padding: 0.35em 1em; font-size: " + props.theme.font.xsmall + ";"
      : props.small
      ? "padding: 0.5em 1.25em; font-size: " + props.theme.font.small + ";"
      : "padding: 0.75em 1.5em; font-weight:300; font-size: " + props.theme.font.base + ";"}
`

export default {
  name: "pr-switch",
  components: {
    PrSwitch
  },
  props: {
    ...Props
  },
  watch: {
    value() {
      this.$nextTick(() => {
        _$.nav._currentScope.currentElement.classList.add("nv")
        if (this.$refs.nv.$el === _$.nav.getCurrentElement()) _$.nav._currentScope.currentElement.classList.add("nv-el-current")
      })
    }
  },
  methods: {
    switcher() {
      this.$emit("update:value", !this.value)
    }
  }
}
</script>
